import containerFuild from '../html-snippets/container-fuild';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-image-with-text-col-1';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Get Started',
  backgroundColor: '#ff6161',
  color: '#ffffff',
  radius: 8,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});

const html = `
<div class="wrap-card container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h1 style="text-align: center;">Lorem ipsum dolor sit amet consectetur adipisicing elit.</h1>
    <p style="text-align: center;">Minus quis, minima nesciunt voluptatem cupiditate adipisci asperiores debitis vel odit consequatur laboriosam ad
      officia quisquam enim aliquid delectus sed veritatis perferendis.</p>
  </div>
  <div data-show="true" data-attribute="wrap-image" class="wrap-image">
    <img data-attribute="card-image" src="https://cdn.skyfastimg.com/images/2026/07/24/image-6a62c718a480b60779b1401d.webp" alt="">
  </div>
  <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>

</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#000000',
  topPadding: true,
  bottomPadding: true,
});
